// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class OrderTypeBaseParameters {
    constructor(instrument = null, account = null, checkSession = true, checkRuleForTrailingStopOrder = true) {
        this.instrument = instrument;
        this.account = account;
        this.checkSession = checkSession;
        this.checkRuleForTrailingStopOrder = checkRuleForTrailingStopOrder;
    }
    setInstrument(instrument) {
        this.instrument = instrument;
    }
    setAccount(account) {
        this.account = account;
    }
    setCheckSession(checkSession) {
        this.checkSession = checkSession;
    }
}
